import { useWidgetPillsAndFilters } from 'hooks/useWidgetPillsAndFilters';

import { useQuerySummaryData } from 'api/queries/summaryData.query';

export type UseChangeSummaryProvider = ReturnType<typeof useChangeSummaryProvider>;

interface Props {
    widgetId?: string;
    globalFilterData: any;
    localFilters: any;
    compareVersionId: number | undefined;
    latestVersionId: number | undefined;
    projectId: number | null | undefined;
    contractId: number | null | undefined;
    endpoints: Record<string, string>;
}

export const useChangeSummaryProvider = ({
    widgetId,
    globalFilterData,
    localFilters,
    compareVersionId,
    latestVersionId,
    projectId,
    contractId,
    endpoints,
}: Props) => {
    const isInPinboard = Boolean(widgetId);
    const source = isInPinboard ? { ...localFilters } : { ...globalFilterData };

    const { filters, pills } = useWidgetPillsAndFilters({ widgetId, source, latestVersionId });

    const getSummaryDataPayload = {
        latestVersionId: latestVersionId,
        compareVersionId: compareVersionId,
        contractId,
        projectId,
        filter: {
            filters,
        },
    };

    const getSummaryData = useQuerySummaryData(getSummaryDataPayload, endpoints.getVersionSummaryCards);

    return {
        ui: {
            state: {
                activityCodes: source.activityCodes,
                milestoneFragnet: source.milestoneFragnet,
                tags: source.tags,
                wbs: source.wbs,
            },
            isInPinboard,
            pills,
        },
        api: {
            getSummaryData: {
                instance: getSummaryData,
                payload: getSummaryDataPayload,
                endpoint: endpoints.getVersionSummaryCards,
            },
        },
    };
};
